interface EmptyStateContentProps {
  message: string;
}

export function EmptyStateContent({ message }: EmptyStateContentProps) {
  return <div className="flex items-center justify-center pt-4 pb-1 text-text-base-tertiary text-xs">{message}</div>;
}
